import {
  colors,
  initialZoom,
  maxZoom,
  minZoom,
  pcWorthMapStyles,
} from "common";

export const mapOptions: google.maps.MapOptions = {
  backgroundColor: colors.primary,
  disableDefaultUI: true,
  styles: pcWorthMapStyles,

  // some zoom options.
  // NOTE: zoom is  allowed but limited because google maps API can reach query limit and to avoid inaccuracy
  maxZoom: maxZoom,
  minZoom: minZoom,
  zoom: initialZoom,
  zoomControl: false,
  zoomControlOptions: null,
  isFractionalZoomEnabled: false,
  disableDoubleClickZoom: false,
};
